module.exports = __webpack_public_path__ + "static/02_data_entry.fd7315f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/02_data_entry.jpg
// module id = 511
// module chunks = 111663361672460